import React, { useState, useEffect } from "react";
import { getEventPosition } from "../../helper/helper";
import "./CurrentTime.css";

const CurrentTime = ({ calculatedWidth }) => {
  const [currentTime, setCurrentTime] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 30000);

    return () => clearInterval(timer);
  }, []);

  return (
    <div
      className="current-time"
      role="current-time"
      style={{
        top: `${
          getEventPosition({
            auditDetails: { dueDateLocalTime: currentTime },
          })?.startPosition
        }px`,
        width: calculatedWidth,
      }}
    >
      <div className="time-label ng_p_2_b">
        <span>
          {currentTime.getHours().toString().padStart(2, "0")}:
          {currentTime.getMinutes().toString().padStart(2, "0")}
        </span>
      </div>
    </div>
  );
};

export default CurrentTime;